import { z } from "zod";

export const updateICafeListPayloadSchema = z.array(z.string());

export type UpdateICafeListPayloadType = z.infer<typeof updateICafeListPayloadSchema>;
